import apiService from './api-service';
import { config } from '../config';

const FUEL_TANKS_TABLE_DISPLAYED_COLUMNS = "fuel-tanks-table-displayed-columns";
const FUEL_TANKS_TABLE_HIDE_SUMMARY = "fuel-tanks-table-hide-summary";
const DRIVERS_TABLE_DISPLAYED_COLUMNS = "drivers-table-displayed-columns";
const NOTIFICATIONS_ENABLED = "notifications-enabled";
const FUEL_VOLUME_PRECISION = "fuel-volume-precision";
const FUEL_VOLUME_PRECISION_DEFAULT = 2;

export const userService = {
	FUEL_TANKS_TABLE_DISPLAYED_COLUMNS,
	FUEL_TANKS_TABLE_HIDE_SUMMARY,
	DRIVERS_TABLE_DISPLAYED_COLUMNS,
	NOTIFICATIONS_ENABLED,
	FUEL_VOLUME_PRECISION,
	FUEL_VOLUME_PRECISION_DEFAULT,
	login,
	logout,
	getUsers,
	getUserInfo,
	updateUserInfo,
	getUserSettings,
	updateUserSettings,
	impersonateUser,
	getUsersByCreatedUser,
	getUserByCreatedUser,
	createUser,
	updateUser,
	deleteUser,
	checkEmailCode
};

async function login(username, password, signature) {
	const result = await apiService.login(`${config.loginUrl}`, username, password, signature);
	return result;
}

async function logout() {
	await apiService.logout('user/logout');
}

async function getUsers() {
	const result = await apiService.get('user/getUsers');
	return result;
}

async function getUserInfo(userId) {
	const options = [
		{
			name: "targetUserId",
			value: userId
		}
	];

	const result = await apiService.get('user/getUserInfo', options);

	return result;
}

async function updateUserInfo(userInfo) {
	const result = await apiService.post('user/updateUserInfo', userInfo);
	return result;
}

async function getUserSettings() {
	const result = await apiService.get('user/getUserSettings');
	return result;
}

async function updateUserSettings(userSettings) {
	const result = await apiService.post('user/updateUserSettings', userSettings);
	return result;
}

function impersonateUser(impersonateUser) {
	try {
		const decodedData = atob(impersonateUser);
		if (!decodedData) {
			return {
				isSuccess: false,
				data: "cannot decode 'data' parameter"
			};
		}

		const authData = JSON.parse(decodedData);
		if (!authData || !authData.accessToken) {
			return {
				isSuccess: false,
				data: "'authData' is invalid"
			};
		}

		apiService.logout();

		localStorage.setItem(apiService.AUTH_DATA_KEY, JSON.stringify(authData));

		return {
			isSuccess: true,
			data: authData
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function getUsersByCreatedUser() {
	const result = await apiService.get('user/getUsersByCreatedUser');
	return result;
}

async function getUserByCreatedUser(useeId) {
	const options = [
		{
			name: "targetUserId",
			value: useeId
		}
	];

	const result = await apiService.get('user/getUserByCreatedUser', options);
	return result;
}

async function createUser(user) {
	const userId = await apiService.post('user/createUser', user);
	return userId;
}

async function updateUser(user) {
	const countUpdatedRows = await apiService.post('user/updateUser', user);
	return countUpdatedRows;
}

async function deleteUser(userId) {
	const user = { userId: userId };

	const countDeletedRows = await apiService.post('user/deleteUser', user);
	return countDeletedRows;
}

async function checkEmailCode(code) {
	const response = await apiService.post(`${config.checkEmailCode.checkEmailCodeUrl}`, { code: code });

	if (response.isSuccess) {
		localStorage.setItem(apiService.AUTH_DATA_KEY, JSON.stringify(response.data));
	}

	return response;
}